"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.HtmlRendererWithoutDocs = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireDefault(require("react"));

var _stencilReactDesc = require("@amzn/stencil-react-desc");

var _context = require("../context");

var _utils = require("../utils");

var _constants = require("./constants");

var _helperComponents = require("./helperComponents");

var _core = require("@emotion/core");

var _excluded = ["html"];

var _templateObject;

var HtmlRendererContainer = (0, _context.styledWithTheme)('div')(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  ", "\n"])), function (_ref) {
  var theme = _ref.theme;
  return (0, _helperComponents.stencilStylesForPrimitives)({
    theme: theme
  });
});

var HtmlRendererWithoutDocs = function HtmlRendererWithoutDocs(_ref2) {
  var html = _ref2.html,
      restProps = (0, _objectWithoutProperties2.default)(_ref2, _excluded);
  var warningIconStyle = 'font-size: 16px; padding: 5px;';
  var warningTextStyle = 'font-weight:bold;text-decoration:underline;';

  if (_constants.XSS_PATTERN.test(html)) {
    console.warn("%c\u26A0\uFE0F%cTo avoid the risk of XSS attacks, it is recommended that you sanitize any input that is being used to render content with the `HtmlRenderer` component.", warningIconStyle, warningTextStyle);
  }

  return (0, _core.jsx)(HtmlRendererContainer, (0, _extends2.default)({}, restProps, {
    dangerouslySetInnerHTML: {
      __html: html
    }
  }));
};

exports.HtmlRendererWithoutDocs = HtmlRendererWithoutDocs;
var HtmlRendererWithDocs = (0, _stencilReactDesc.describe)(HtmlRendererWithoutDocs).description('Container to render and style a raw HTML code');
var HtmlRenderer = (0, _utils.withTestAttributes)({
  component: 'StencilHtmlRenderer'
})(HtmlRendererWithDocs);
HtmlRenderer.displayName = 'HtmlRenderer';
HtmlRenderer.propTypes = {
  html: _stencilReactDesc.PropTypes.string.isRequired
};
var _default = HtmlRenderer;
exports.default = _default;